import request from "@/utils/request";
import { MonitorOverviewRequest, MonitorOverviewData, GroupedOverviewData } from "@/types/datachart"

// Transform raw API response into grouped structure for better state management
const transformOverviewData = (data: MonitorOverviewData): GroupedOverviewData => {
    return {
        overall: {
            total_reward: data.total_reward,
            agent_reward: data.agent_reward,
            direct_reward: data.direct_reward,
            total_invite: data.total_invite,
            agent_invite: data.agent_invite,
            direct_invite: data.direct_invite,
            total_deposit_user: data.total_deposit_user,
            total_trade_user: data.total_trade_user,
            dau: data.dau,
            claimable: data.claimable,
        },
        period: {
            period: data.period,
            period_volume_usdt: data.period_volume_usdt,
            period_customers: data.period_customers,
            period_commission_usdt: data.period_commission_usdt,
            period_net_trade_fee_usdt: data.period_net_trade_fee_usdt,
            period_reward: data.period_reward,
            period_invite: data.period_invite,
        },
        comparison: {
            comparison_volume_usdt: data.comparison_volume_usdt,
            comparison_customers: data.comparison_customers,
            comparison_commission_usdt: data.comparison_commission_usdt,
            comparison_net_trade_fee_usdt: data.comparison_net_trade_fee_usdt,
            comparison_reward: data.comparison_reward,
            comparison_invite: data.comparison_invite,
        },
        growth: {
            volume_growth_rate: data.volume_growth_rate,
            customer_growth_rate: data.customer_growth_rate,
            commission_growth_rate: data.commission_growth_rate,
            net_trade_fee_growth_rate: data.net_trade_fee_growth_rate,
            reward_growth_rate: data.reward_growth_rate,
            invite_growth_rate: data.invite_growth_rate,
        },
        last_updated: data.last_updated,
        invite_codes: data.invite_codes,
        recent_direct_users: data.recent_direct_users,
        commission_chart_data: data.commission_chart_data,
        customers_chart_data: data.customers_chart_data,
    };
};

export const fetchOverviewData = async (query: MonitorOverviewRequest): Promise<GroupedOverviewData> => {
    console.log('fetchOverviewData CALLED', query);
    const res = await request.post<MonitorOverviewData>('/monitor/overview', query);
    console.log('fetchOverviewData RES', res);
    return transformOverviewData(res);
};

export const claimableReward = async (): Promise<{}> => {
    const res = await request.post<{}>('/monitor/claim');
    return res;
};